import { SectionHeading } from '~/components/ui/SectionHeading';
import { StyledContainer } from './Section.styled';

interface ISectionProps extends React.HTMLAttributes<HTMLDivElement> {
	icon: string;
	text: string;
	nameStyle?: React.CSSProperties;
	color?: string;
	nameOpacity?: number;
}

const Section = ({
	icon,
	text,
	children,
	nameStyle,
	color = '#ffffff',
	nameOpacity = 0.75,
	...props
}: ISectionProps) => (
	<StyledContainer {...props}>
		<SectionHeading
			icon={icon}
			text={text}
			fontWeight={500}
			style={{ ...nameStyle, marginBottom: 20 }}
			iconColor={color}
			textColor={color}
			textOpacity={nameOpacity}
			iconOpacity={nameOpacity}
		/>
		{children}
	</StyledContainer>
);

export { Section };
